import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Button from 'components/Button';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import ToolbarButton from 'components/ToolbarButton';
import Text from 'components/Text';
import SearchBox from 'components/SearchBox';
import { VIEW_KEYS } from './useItemPickerView';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LINE_HEIGHT = 1.3;
export var DEFAULT_CONTENT_HEIGHT = 366;
function ItemPickerUI(props) {
  var isSubmitDisabled = props.isSubmitDisabled,
    isSingleItemPicker = props.isSingleItemPicker,
    children = props.children,
    renderFilterMenu = props.renderFilterMenu,
    searchValue = props.searchValue,
    onSearchValueChange = props.onSearchValueChange,
    selectedItemCount = props.selectedItemCount,
    onSubmit = props.onSubmit,
    onClose = props.onClose,
    view = props.view,
    onChangeView = props.onChangeView,
    customLabels = props.labels,
    _props$contentHeight = props.contentHeight,
    contentHeight = _props$contentHeight === void 0 ? DEFAULT_CONTENT_HEIGHT : _props$contentHeight,
    scrollContainerRef = props.scrollContainerRef;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var labels = useMemo(function () {
    return _objectSpread({
      noSelectionMessage: t('no_selection'),
      getSelectionStatus: function getSelectionStatus(count) {
        return t('generic_selection_status', {
          count: count
        });
      },
      viewSelectionButtonLabel: t('actions_view_selection'),
      viewAllButtonLabel: t('actions_view_all'),
      submitButtonLabel: t('actions_confirm_selection'),
      backButtonLabel: t('actions_back'),
      closeButtonLabel: t('actions_close_modal'),
      searchLabel: t('actions_search_hellip'),
      searchPlaceholder: t('actions_search_hellip')
    }, customLabels);
  }, [customLabels, t]);
  function handleBackButton() {
    if (typeof view.onGoBack === 'function') {
      view.onGoBack();
    } else if (typeof view.onGoBack === 'string') {
      onChangeView(view.onGoBack);
    }
  }
  return /*#__PURE__*/_jsxs(Card, {
    variant: "raised",
    children: [/*#__PURE__*/_jsxs(Box, {
      as: "header",
      borderBottom: "thin",
      children: [/*#__PURE__*/_jsxs(Flex, {
        children: [view.onGoBack && /*#__PURE__*/_jsx(Box, {
          mr: "-m",
          children: /*#__PURE__*/_jsx(ToolbarButton, {
            icon: "arrow",
            title: labels.backButtonLabel,
            onClick: handleBackButton
          })
        }), /*#__PURE__*/_jsx(Box, {
          grow: true,
          shrink: true,
          basis: 0,
          px: "m",
          py: "s",
          children: /*#__PURE__*/_jsx(Heading, {
            as: "h1",
            id: "search-picker-title",
            children: view.title
          })
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(ToolbarButton, {
            icon: "x",
            title: labels.closeButtonLabel,
            onClick: onClose
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        px: "m",
        pb: "s",
        children: [/*#__PURE__*/_jsx(Box, {
          as: "form",
          role: "search",
          grow: true,
          shrink: true,
          minWidth: "50%",
          onSubmit: function onSubmit(e) {
            e.stopPropagation();
            e.preventDefault();
          },
          children: /*#__PURE__*/_jsx(SearchBox, {
            "data-autofocus": true,
            required: true,
            withBorder: true,
            label: labels.searchLabel,
            placeholder: labels.searchPlaceholder,
            value: searchValue,
            onChange: function onChange(e) {
              return onSearchValueChange(e.currentTarget.value);
            },
            onClear: function onClear() {
              return onSearchValueChange('');
            }
          })
        }), renderFilterMenu && /*#__PURE__*/_jsx(Box, {
          shrink: true,
          pl: "xs",
          mr: -10,
          overflow: "hidden",
          children: renderFilterMenu()
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      ref: scrollContainerRef,
      height: contentHeight,
      overflow: "auto",
      children: children
    }), /*#__PURE__*/_jsxs(Flex, {
      as: "footer",
      borderTop: "thin",
      textAlign: "center",
      p: "s",
      minHeight: 80,
      children: [/*#__PURE__*/_jsx(Box, {
        grow: true,
        shrink: true,
        px: "m",
        children: selectedItemCount > 0 ? /*#__PURE__*/_jsxs(Text, {
          lineHeight: LINE_HEIGHT,
          children: [!isSingleItemPicker && /*#__PURE__*/_jsxs(_Fragment, {
            children: [labels.getSelectionStatus(selectedItemCount), /*#__PURE__*/_jsx("br", {})]
          }), view.key === VIEW_KEYS.SELECTED ? /*#__PURE__*/_jsx(Button, {
            size: "small",
            variant: "transparent",
            onClick: function onClick() {
              return onChangeView(VIEW_KEYS.DEFAULT);
            },
            children: labels.viewAllButtonLabel
          }) : /*#__PURE__*/_jsx(Button, {
            size: "small",
            variant: "transparent",
            onClick: function onClick() {
              return onChangeView(VIEW_KEYS.SELECTED);
            },
            children: labels.viewSelectionButtonLabel
          })]
        }) : /*#__PURE__*/_jsx(Text, {
          dimmed: true,
          children: labels.noSelectionMessage
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          icon: "ok",
          onClick: onSubmit,
          isDisabled: isSubmitDisabled,
          children: labels.submitButtonLabel
        })
      })]
    })]
  });
}
export default ItemPickerUI;